import { createContext } from 'react'

/**
 * FF-QA-138: `DataTable` tells the `QueryBoundary` rendered as its children
 * how many columns it has, so a loading register draws skeleton rows the
 * shape of the table instead of a bare "Loading…" line in an empty card.
 */
export const DataTableSkeletonContext = createContext<{ columns: number } | undefined>(undefined)
